import React from 'react';
import { Tabs } from 'antd';
import { SelectTabsContainer, TabPane } from './styles';
import { ScheduleType as ScheduleTypeConstants, ExchangeType as ExchangeTypeConstants } from '../../constants';

const ScheduleType = (props) => {
    return (
        <SelectTabsContainer>
            <Tabs
                className = "tabExchange"
                type="card"
                onChange={props.handleChange}
                tabBarExtraContent={'Select schedule type'}
                defaultActiveKey={ScheduleTypeConstants.onetime}
                activeKey={props.activeKey || ScheduleTypeConstants.onetime}
            >
                <TabPane tab={'One-time Exchange'} key={ScheduleTypeConstants.onetime}>
                    {props.content}
                </TabPane>
                <TabPane tab={'Recurring Exchange'} key={ScheduleTypeConstants.recurring}>
                    {props.content}
                </TabPane>
                <TabPane tab={'TIFF Exchange'} key={ScheduleTypeConstants.tiff}>
                        {props.content}
                </TabPane>
               
            </Tabs>
        </SelectTabsContainer>
    );
}

export default ScheduleType;